import { DataTable, DatePicker, DateRangePicker } from "components/common"
import { useLazyGetProfileSummaryQuery, useLazyGetFilteredActivityLogQuery } from "features/shared/api"
import { useEffect, useMemo, useCallback, useState } from "react"
import { convertTo12HourFormat, dateTimeFunction } from "utils/date"
import { DATE_FORMAT, DATE_TIME_FORMAT } from "constants"
import styles from "./index.module.less"
import { t } from "i18next"
import dayjs from "dayjs"
import { notification } from "antd"

const ActivityLogs = ({ staffId }) => {
  const columns = [
    { title: t("TIME"), dataIndex: "time" },
    { title: t("UQC"), dataIndex: "uniqueQualifiedCalls" },
    { title: t("CALLS"), dataIndex: "calls" },
    { title: t("U.MET"), dataIndex: "uniqueMeetingsDone" },
  ]

  const [getProfileSummary, { data, isFetching, error }] = useLazyGetProfileSummaryQuery()
  const [date, setDate] = useState(null)

  useEffect(() => {
    getProfileSummary({ staffId, load: "activityLogs" }, true)
  }, [])

  const tableData = useMemo(() => {
    if (data) {
      return (data?.activityLogs).map((values, index) => {
        return {
          key: index,
          time:
            dateTimeFunction({ date: values.from, timeZone: true, format: DATE_TIME_FORMAT }).slice(11, -3) +
            " - " +
            dateTimeFunction({ date: values.to, timeZone: true, format: DATE_TIME_FORMAT }).slice(11, -3),
          uniqueQualifiedCalls: values.uniqueQualifiedCalls,
          calls: values.calls,
          uniqueMeetingsDone: values.unqiueMeetingsDone,
        }
      })
    }

    return []
  }, [data])

  const handleOnChange = date => {
    // const fromDate = encodeURIComponent(
    //   dateTimeFunction({ date: dayjs(date)?.startOf("day"), apiRequest: true, timeZone: true })
    // )
    const toDate = encodeURIComponent(
      dateTimeFunction({ date: dayjs(date)?.endOf("day"), apiRequest: true, timeZone: true })
    )
    getProfileSummary({ staffId, load: "activityLogs", params: { toDate } }, true)
  }

  return (
    <>
      <DatePicker
        onChange={handleOnChange}
        format={DATE_FORMAT}
        showTime={false}
        defaultValue={date ? dayjs(decodeURIComponent(date)) : dayjs()}
        disabledDate={date => {
          return date && dayjs(date)?.isAfter(dayjs(), "day")
        }}
        style={{
          maxWidth: 180,
        }}
        allowClear={false}
      />
      <br />
      <br />
      <DataTable
        className={styles.activityTable}
        stickyOffset={-24}
        error={error}
        data={tableData || []}
        noUrlPush={true}
        loading={isFetching}
        columns={columns || []}
      />
    </>
  )
}

export default ActivityLogs
